module.exports = __webpack_public_path__ + "media/images/parallax/illustration-connect-middleground-825c36222d8b929595eb0424e1954e3c.png";